import { render, staticRenderFns } from "./EditPlanBuilder.vue?vue&type=template&id=2d653523&scoped=true"
import script from "./EditPlanBuilder.vue?vue&type=script&lang=js"
export * from "./EditPlanBuilder.vue?vue&type=script&lang=js"
import style0 from "./EditPlanBuilder.vue?vue&type=style&index=0&id=2d653523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d653523",
  null
  
)

export default component.exports